module.exports = __webpack_public_path__ + "img/4 of meer kamers.d0c48e90.png";